import { jsx as r } from "react/jsx-runtime";
import { createContext as u, useContext as a } from "react";
const n = u(void 0), o = (e) => {
  const t = {
    countries: e.countries,
    languages: e.languages,
    currentCountryCode: e.currentCountryCode,
    currentLanguageCode: e.currentLanguageCode,
    updateCountryAndLanguage: e.updateCountryAndLanguage
  };
  return /* @__PURE__ */ r(n.Provider, { value: t, children: e.children });
};
o.displayName = "CountriesAndLanguagesProvider";
const d = () => {
  const e = a(n);
  if (!e)
    throw new Error(
      "useCountriesAndLanguages must be used within a CountriesAndLanguagesProvider"
    );
  return e;
};
export {
  o as CountriesAndLanguagesProvider,
  d as useCountriesAndLanguages
};
